import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../css/RxartSecure/DevicesRS.module.css'
import { formatDate } from '../../../generals/charts/utils/DatesFormats'
import { Button } from 'reactstrap'
import $ from 'jquery'
import { postData } from '../../../../actions/servicesHttp'
import { popupSimple } from '../../../generals/popups'
import store from '../../../../reducer/store'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function DevicesRS ({ data, setData, device, bios, setBios, setComponentsModalRS, setActiveIndex, modalsShow, setModalsShow, close }) {
  const { t } = useTranslation('dashboardDevice')
  const navigate = useNavigate()
  const { user } = store.getState()

  const [activateLicense, setActivateLicense] = useState(false)
  const [rxartSecureLicenseActivation] = useState('rxartsecure/license_activation')
  const [codeActivation, setCodeActivation] = useState({
    codeActivation: '',
    deviceId: data?.device?.deviceId
  })

  const typesDevice = [
    { key: 'desktop', value: t('modalRxartSecure.label15') },
    { key: 'notebook', value: t('modalRxartSecure.label16') },
    { key: 'tablet', value: t('modalRxartSecure.label17') },
    { key: 'smartphone', value: t('modalRxartSecure.label18') }
  ]

  const deviceTypeLabel =
    typesDevice.find(
      type => type.key === data?.device?.deviceType?.toLowerCase()
    )?.value || data?.device?.deviceType

  const handleInputChange = (e) => {
    // console.log(e, 'linea 12')

    let symbol = e.target.value.toUpperCase()
    symbol = symbol.replace(/[^0-9A-F]/g, '')
    symbol = symbol.slice(0, 20)

    const formatted = symbol.match(/.{1,5}/g)?.join('-') || ''

    setCodeActivation({
      ...codeActivation,
      [e.target.name]: formatted
    })
  }

  const useActivationCode = async (id, code, url, close) => {
    $('#btnSucessModalRSActivateLicense').prop('disabled', true)
    if (code?.codeActivation === '') {
      popupSimple('info', t('modalRxartSecure.label71'))
    } else {
      const body = {
        deviceId: code?.deviceId,
        codeActivation: code?.codeActivation.replace(/ /g, ''),
        userId: id
      }

      const response = await postData(url, body, navigate)
      if (response.status < 299) {
        popupSimple('success', t('modalRxartSecure.label39'))
        close()
      } else {
        console.log(response, 'linea 68')
        if (response.data.message?.includes('Código/s de activación utilizado/s')) {
          popupSimple('error', t('modalRxartSecure.label79'))
        } else {
          popupSimple('error', t('modalRxartSecure.label70'))
        }
        setCodeActivation({
          codeActivation: '',
          deviceId: data?.device?.deviceId
        })
        console.log({ error: true, response })
      }
    }
    $('#btnSucessModalRSActivateLicense').prop('disabled', false)
  }

  return (
    <div className={styles.devicesContainer}>
      <div className={styles.inputContainer}>
        <label>{t('modalRxartSecure.label23')}</label>
        <input type="text" value={data?.device?.deviceId} name="deviceId" disabled />
      </div>
      <div className={styles.doubleInput}>
        <div className={styles.inputContainer}>
          <label>{t('modalRxartSecure.label21')}</label>
          <input type="text" value={bios} name="bios" disabled />
        </div>
        <div className={styles.inputContainer}>
          <label>{t('modalRxartSecure.label22')}</label>
          {data?.device?.license !== 'No disponible' && <input type="text" value={data?.device?.license} name="license" disabled />}
          {data?.device?.license === 'No disponible' && <p className={styles.licenseActivationMessage} onClick={() => setActivateLicense(!activateLicense)}>+ {t('modalRxartSecure.label20')}</p>}
          {activateLicense && <div>
              <label>{t('modalRxartSecure.label54')}</label>
              <input type="text" value={codeActivation?.codeActivation}
                placeholder="01234-56789-ABCDE-F0123"
                name="codeActivation"
                id="inputCodeActivation"
                maxLength={23}
                onChange={(e) => handleInputChange(e)}
                className={styles.codeActivateLicense}
              />
              <div className={styles.btnsActivateLicense}>
                <Button
                  onClick={() => useActivationCode(user?.userId, codeActivation, rxartSecureLicenseActivation, close)} variant="primary"
                  id="btnSucessModalRSActivateLicense"
                  className={styles.btnSucess}
                >
                  {t('modalRxartSecure.button10')}
                </Button>
                <Button
                  onClick={() => {
                    setCodeActivation({
                      codeActivation: '',
                      deviceId: device?.device?.deviceId
                    })
                    setActivateLicense(false)
                  }}
                  variant="danger"
                  className={styles.btnCancel}
                >
                  {t('modalRxartSecure.button1')}
                </Button>
              </div>
            </div>}
        </div>
      </div>
      <div className={styles.doubleInput}>
              <div className={styles.inputContainer}>
                <label>{t('modalRxartSecure.label72')}</label>
                <input type="text" value={deviceTypeLabel} name="deviceType" disabled />
              </div>
              <div className={styles.inputContainer}>
                <label>{t('modalRxartSecure.label73')}</label>
                <input type="text" value={formatDate(data?.device?.lastDate)} name="lastConection" disabled />
              </div>
      </div>
    </div>
  )
}

DevicesRS.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  device: PropTypes.object,
  bios: PropTypes.string,
  setBios: PropTypes.func,
  setComponentsModalRS: PropTypes.func,
  setActiveIndex: PropTypes.func,
  modalsShow: PropTypes.object,
  setModalsShow: PropTypes.func,
  close: PropTypes.func
}
